import axios from '@/config/backend'

function prepareParams(config) {
    return new Promise((resolve, reject) => {
        var field = config.sort

        if (config.sortDirection === 'desc') {
            field = '-' + field
        }

        var params = {
            page: config.page,
            include: config.include,
            sort: field,
            per_page: config.per_page
        }

        if (config.filters) {
            for (const [key, value] of Object.entries(config.filters)) {
                params[`filter[${key}]`] = value
            }
        }

        resolve(params)
    })
}

export default {
    saveUserAnswer({ commit }, attribute) {
        return new Promise((resolve, reject) => {
            try {
                commit('addAttribute', attribute)
                resolve()
            } catch (error) {
                reject(error)
            }
        })
    },
    sendPost({ rootState, state }) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/${rootState.lang}/posts`, {
                    post: state.post,
                    locale: rootState.lang,
                    firebase: rootState.firebaseToken,
                    client_url: rootState.vueAppBaseUrl
                })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    getPosts({ state, rootState, commit }) {
        return new Promise((resolve, reject) => {
            try {
                prepareParams(state.postsConfig).then((params) => {
                    axios
                        .get(`/${rootState.lang}/posts`, {
                            params
                        })
                        .then((response) => {
                            commit('setPosts', response.data.posts)
                            commit(
                                'setUnreadMessage',
                                response.data.unread_messages
                            )
                            resolve(response)
                        })
                        .catch((error) => {
                            reject(error)
                        })
                })
            } catch (error) {
                reject(error)
            }
        })
    },
    getPostsByToken({ state, rootState, commit }) {
        return new Promise((resolve, reject) => {
            try {
                prepareParams(state.postsConfig).then((params) => {
                    params.firebase = rootState.firebaseToken
                    axios
                        .get(`/${rootState.lang}/posts/token`, {
                            params
                        })
                        .then((response) => {
                            commit('setPosts', response.data.posts)
                            commit(
                                'setUnreadMessage',
                                response.data.unread_messages
                            )
                            resolve(response)
                        })
                        .catch((error) => {
                            reject(error)
                        })
                })
            } catch (error) {
                reject(error)
            }
        })
    },
    getPost({ rootState, commit }, id) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/${rootState.lang}/posts/${id}`, {
                    params: {
                        firebase: rootState.firebaseToken
                    }
                })
                .then((response) => {
                    commit('setPostView', response.data.post)
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    getPostByToken({ rootState, commit }, id) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/${rootState.lang}/posts/token/${id}`, {
                    params: {
                        firebase: rootState.firebaseToken
                    }
                })
                .then((response) => {
                    commit('setPostView', response.data.post)
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    getPostByKey({ rootState, commit }, key) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/${rootState.lang}/posts/key/${key}`, {})
                .then((response) => {
                    commit('setPostView', response.data.post)
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    sendNewMessage({ rootState, state }, content) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${rootState.lang}/posts/${content.post_id}/messages`, {
                    content: content.content,
                    client_url: rootState.vueAppBaseUrl
                })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }
}
